import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { SpecieFamilyService } from '../proxy/planning/controllers/specie-family.service';

FieldBuilder.setNamespace('Planning');

export const FLORASPECIE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.FloraSpecie.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('code', 'Entity.FloraSpecie.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
  FieldBuilder
    .checkbox('isNative', 'Entity.FloraSpecie.IsNative')
    .build(),
  FieldBuilder
    .checkbox('isPriority', 'Entity.FloraSpecie.IsPriority')
    .build(),
  FieldBuilder
    .checkbox('isThreaten', 'Entity.FloraSpecie.IsThreaten')
    .build(),
  FieldBuilder
    .number('aaa', 'Entity.FloraSpecie.AAA')
    .required()
    .build(),
  FieldBuilder
    .checkbox('a1', 'Entity.FloraSpecie.A1')
    .build(),
  FieldBuilder
    .checkbox('a2', 'Entity.FloraSpecie.A2')
    .build(),
  FieldBuilder
    .checkbox('a3', 'Entity.FloraSpecie.A3')
    .build(),
  FieldBuilder
    .checkbox('a4', 'Entity.FloraSpecie.A4')
    .build(),
  FieldBuilder
    .text('cites', 'Entity.FloraSpecie.Cites')
    .required()
    .maxLength(10)
    .build(),
  FieldBuilder
    .text('iucn', 'Entity.FloraSpecie.IUCN')
    .maxLength(10)
    .required()
    .build(),
  FieldBuilder
    .foreignKey('specieFamilyId', 'Entity.SpecieFamily', SpecieFamilyService)
    .displayFromNested('specieFamily.name')
    .sortBy('specieFamily.name')
    .build(),
];

export const FLORASPECIE_CONFIG = {
  entityName: 'FloraSpecie',
  localizationKey: 'Planning::Entity.FloraSpecie',
  fields: FLORASPECIE_FIELDS,
  permission: 'PlanningEnvironment.FloraSpecies',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Environment + MENU_NAME_SUFFIX,
};
